import Instance from "../../../../Axios";

// New Actions for the app

const GetCredCredenciacoesByEstado = (estado) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/credCredenciacoesByEstado/${estado}`)
    .then(({ data }) => {
      dispatch({ type: "GET_CRED_CREDENCIACOES_BY_ESTADO", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredCredenciacoesByEstado;
